const Call = ({ color = "#191919", width = 24, height = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 2.709 2.709"
    width={width}
    height={height}
    fillRule="evenodd"
    clipRule="evenodd"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    {...props}
  >
    <path fill="none" d="M0 0h2.709v2.709H0z" />
    <path
      fill={color}
      fillRule="nonzero"
      d="M.386.583h.002V.581L.41.559C.524.445.616.354.704.304c.188-.105.34-.027.583.405a.043.043 0 0 1-.004.048l-.268.358c-.021.028.015.107.078.2.053.078.125.162.2.236.077.074.157.138.227.177.06.034.11.048.133.028l.334-.287a.043.043 0 0 1 .05-.004c.42.244.481.402.376.583-.047.08-.13.163-.227.26l-.033.033h-.001c-.218.21-.623.085-1.004-.182a2.85 2.85 0 0 1-.413-.356 2.352 2.352 0 0 1-.322-.415C.23 1.078.178.773.386.583zM.472.62.45.64a.042.042 0 0 1-.004.005c-.174.156-.124.423.04.7.08.134.188.27.31.398.123.128.26.246.4.345.35.245.713.367.895.192l.033-.033c.094-.093.172-.171.213-.242.075-.129.02-.25-.318-.45l-.311.267c-.055.047-.138.033-.23-.018a1.222 1.222 0 0 1-.245-.191 1.675 1.675 0 0 1-.212-.25c-.084-.123-.123-.237-.076-.3l.252-.336C.997.374.878.305.746.38.668.423.58.51.472.62z"
    />
  </svg>
);

export default Call;
